import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from '../api/client';

const ApiContext = createContext<ApiClient | null>(null);

export interface ApiProviderProps {
  client: ApiClient;
  children: ReactNode;
}

export const ApiProvider = ({ client, children }: ApiProviderProps) => (
  <ApiContext.Provider value={client}>{children}</ApiContext.Provider>
);

export const useApi = (): ApiClient => {
  const ctx = useContext(ApiContext);
  if (!ctx) {
    throw new Error('useApi must be used inside <ApiProvider>.');
  }
  return ctx;
};
